import { useEffect, useState } from 'react';
import { getPreachingsByPreacher, localCache } from '@/lib/api';
import { getLocalDateString } from '@/lib/date';

export function useTodayPreaching(personId, districtId) {
  const [todayPreachings, setTodayPreachings] = useState([]);

  useEffect(() => {
    if (!personId || !districtId) return;
    const todayStr = getLocalDateString();
    const cacheKey = `preaching_today_${personId}_${todayStr}`;

    // Serve cached value immediately (stale-while-revalidate) so the Dashboard
    // renders preaching info on the first tick instead of waiting for the network.
    localCache.get(cacheKey).then((cached) => {
      if (cached) setTodayPreachings(cached);
    });

    // Background refresh — updates state and cache when network resolves.
    // getPreachingsByPreacher now has a 3s timeout (reduced from 8s).
    getPreachingsByPreacher(personId, districtId)
      .then((assignments) => {
        const filtered = assignments.filter((a) => a.date === todayStr);
        setTodayPreachings(filtered);
        localCache.set(cacheKey, filtered).catch(() => {});
      })
      .catch(() => {});
  }, [personId, districtId]);

  return { todayPreachings };
}
